import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/userprofile.png'


const _withScopeId = n => (_pushScopeId("data-v-433d3605"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card p-4"
}
const _hoisted_2 = { class: "image d-flex flex-column justify-content-center align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-secondary" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    height: "100",
    width: "100"
  })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_6 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "email" }
const _hoisted_9 = { class: "px-2 rounded mt-4 date" }
const _hoisted_10 = { class: "join" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "log-out",
    href: "/accounts/logout/"
  }, "Log Out")
], -1))

import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useEmployeeStore } from '@/stores/UserEmployee';
import UserEditProfile from '@/views/UserEditProfile.vue';

type UserProfileType = {
  name: string;
  email: string;
  joinedDate: string;
};

// Component setup

export default /*#__PURE__*/_defineComponent({
  __name: 'AppProfileCard',
  setup(__props) {

const userEmployeeStore = useEmployeeStore();

// Define a type for userProfile
const userProfile = ref<UserProfileType>({
  name: '',
  email: '',
  joinedDate: ''
});
const isEditing = ref(false);
const router = useRouter();

const formatDate = (dateInput: Date | string): string => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  let date: Date;

  if (dateInput instanceof Date) {
    date = dateInput;
  } else {
    date = new Date(dateInput);
  }

  return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
};

const fetchUserData = async (): Promise<void> => {
  try {
    const userStore = useEmployeeStore();
    await userStore.fetch();
    const currentUser = userStore.currentUser;
    if (currentUser) {
      userProfile.value.name = currentUser.user.full_name;
      userProfile.value.email = currentUser.user.email;
      userProfile.value.joinedDate = formatDate(currentUser.user.date_joined);
    }
  } catch (error) {
    console.error('Error fetching user data:', error);
  }
};

const navigateToEditProfile = (): void => {
  router.push({ name: 'edit-profile' });
};

onMounted(() => {
  fetchUserData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!isEditing.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            (_unref(userEmployeeStore).currentUser?.user.is_superuser)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Admin"))
              : _createCommentVNode("", true),
            (_unref(userEmployeeStore).currentUser?.user.is_staff && !_unref(userEmployeeStore).currentUser?.user.is_superuser)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Manager"))
              : _createCommentVNode("", true),
            (!_unref(userEmployeeStore).currentUser?.user.is_superuser && !_unref(userEmployeeStore).currentUser?.user.is_staff)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Employee"))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_7, _toDisplayString(userProfile.value.name), 1),
            _createElementVNode("span", _hoisted_8, _toDisplayString(userProfile.value.email), 1),
            _createElementVNode("div", { class: "d-flex mt-2" }, [
              _createElementVNode("button", {
                class: "btn1 btn-dark",
                style: {"border-radius":"25px"},
                onClick: navigateToEditProfile
              }, "Edit Profile")
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, "Joined -" + _toDisplayString(userProfile.value.joinedDate), 1)
            ]),
            _hoisted_11
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})